export default {
  init() {
    //
  },
  finalize() {
    function setCookie(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    setCookie("nl", "1", 60);
    $(".btn-nl").fadeOut(function () {
      $(this).remove();
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/newsletter.js